import { useStore } from "@nanostores/react";
import { valuesStore } from "@/components/search/_utils/searchStore";

export const Reset = () => {
  const values = useStore(valuesStore);

  if (values.length !== 0)
    return (
      <p className="text-base underline cursor-pointer" onClick={() => valuesStore.set([])}>
        Réinitialiser
      </p>
    );

  return null;
};
